// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ti_Rk{color:green}.v2wC6{margin-block-end:5px;color:green}.PIRX8{margin-left:20px}`, "",{"version":3,"sources":["webpack://./src/components/AiOutput/AiOutputTextBlock/AiOutputTextBlock.module.scss"],"names":[],"mappings":"AACA,OACE,WAAA,CAGF,OACE,oBAAA,CACA,WAAA,CAGF,OACE,gBAAA","sourcesContent":["@import \"/home/runner/work/commerce-studio/commerce-studio/apps/commerce-studio/src/styles/shared/utils.scss\";\n.infoText {\n  color: green;\n}\n\n.outputDataArray {\n  margin-block-end: 5px;\n  color: green;\n}\n\n.outputtedObject {\n  margin-left: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoText": `ti_Rk`,
	"outputDataArray": `v2wC6`,
	"outputtedObject": `PIRX8`
};
export default ___CSS_LOADER_EXPORT___;
